import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store, setToastFunction } from '@app/store';
import { Toaster } from '@mehir/web-ui/toaster';
import { toast } from '@mehir/web-ui/hooks/use-toast';

interface AppProviderProps {
  children: React.ReactNode;
}

// Component to set up toast function for store middleware
const ToastSetup: React.FC = () => {
  useEffect(() => {
    // Set up toast function for RTK Query error middleware
    setToastFunction((message: string, title?: string) => {
      toast({
        variant: 'destructive',
        title: title || 'Hata',
        description: message,
      });
    });
  }, []);

  return null;
};

// No PersistGate: the auth slice is no longer persisted (see store/index.ts),
// and it was the only persisted reducer. The session is restored from
// localStorage by useAuth instead.
export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <Provider store={store}>
      <ToastSetup />
      {children}
      <Toaster />
    </Provider>
  );
};
